import { NotificationActions } from './actions';

export const NotificationStates = {
    NotificationError: NotificationActions.NotificationError,
    NotificationInfo: NotificationActions.NotificationInfo,
    NotificationSuccess: NotificationActions.NotificationSuccess,
    NotificationWarning: NotificationActions.NotificationWarning,
};